import { Mail, Phone, MapPin, Facebook, Twitter, Instagram, Linkedin, ArrowUp } from "lucide-react";

const Footer = () => {
  const officeLocations = [
    { city: "Westlands", address: "Waiyaki Way, Nairobi" },
    { city: "Riverside", address: "Riverside Drive, Nairobi" },
    { city: "Kileleshwa", address: "Kileleshwa Road, Nairobi" },
    { city: "Lavington", address: "Lavington Road, Nairobi" },
    { city: "Kilimani", address: "Kilimani Road, Nairobi" }
  ];

  const quickLinks = [
    { name: "Properties for Sale", href: "/properties-for-sale" },
    { name: "Properties for Rent", href: "/properties-for-rent" },
    { name: "Locations", href: "/locations" },
    { name: "Off-Plan Investments", href: "/off-plan-investments" },
    { name: "About Us", href: "/about" },
    { name: "Contact", href: "/contact" }
  ];

  const services = [
    "Property Acquisition",
    "Investment Advisory", 
    "Property Management",
    "Client Representation",
    "Rental Services"
  ];

  const locations = [
    { name: "Westlands", href: "/locations" },
    { name: "Riverside", href: "/locations" },
    { name: "Kileleshwa", href: "/locations" },
    { name: "Lavington", href: "/locations" },
    { name: "Kilimani", href: "/locations" }
  ];

  const socialLinks = [
    { icon: Facebook, href: "#", label: "Facebook" },
    { icon: Phone, href: "tel:+254111653233", label: "+254 111 653 233" },
    { icon: Instagram, href: "#", label: "Instagram" },
    { icon: Linkedin, href: "#", label: "LinkedIn" }
  ];

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <footer className="bg-brand-gradient border-t border-accent/25">
      <div className="px-8 md:px-16 py-20">
        {/* Main Footer Content */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-12 mb-16">
          {/* Brand Section */}
          <div className="lg:col-span-2">
            <div className="flex items-center gap-3 mb-6">
              <img src="/logo2f.png" alt="Wild Gates Real Estate" className="h-16 w-auto object-contain" />
            </div>
            <p className="font-body text-sm text-primary-foreground/70 max-w-sm leading-relaxed mb-6">
              Kenya's premier luxury real estate firm, curating exceptional properties and 
              facilitating seamless transactions for over three decades.
            </p>
            
            {/* Social Links */}
            <div className="flex gap-3 mb-6">
              {socialLinks.map((social) => (
                <a
                  key={social.label}
                  href={social.href}
                  className="p-2 bg-accent/10 rounded-lg text-accent hover:bg-accent/20 transition-colors"
                  aria-label={social.label}
                >
                  <social.icon className="w-4 h-4" />
                </a>
              ))}
            </div>

            {/* Contact Info */}
            <div className="space-y-3">
              <div className="flex items-center gap-3">
                <Phone className="w-4 h-4 text-accent" />
                <span className="font-body text-sm text-primary-foreground/70">
                  +254 111 653 233
                </span>
              </div>
              <div className="flex items-center gap-3">
                <Mail className="w-4 h-4 text-accent" />
                <span className="font-body text-sm text-primary-foreground/70">
                  info@wildgates.co.ke
                </span>
              </div>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="font-body text-xs tracking-widest uppercase text-accent mb-6">
              Quick Links
            </h3>
            <div className="space-y-3">
              {quickLinks.map((link) => (
                <a
                  key={link.name}
                  href={link.href}
                  className="block font-body text-sm text-primary-foreground/60 hover:text-accent transition-colors"
                >
                  {link.name}
                </a>
              ))}
            </div>
          </div>

          {/* Services */}
          <div>
            <h3 className="font-body text-xs tracking-widest uppercase text-accent mb-6">
              Services
            </h3>
            <div className="space-y-3">
              {services.map((service) => (
                <span
                  key={service}
                  className="block font-body text-sm text-primary-foreground/60"
                >
                  {service}
                </span>
              ))}
            </div>
          </div>

          {/* Locations */}
          <div>
            <h3 className="font-body text-xs tracking-widest uppercase text-accent mb-6">
              Locations
            </h3>
            <div className="space-y-3">
              {locations.map((location) => (
                <a
                  key={location.name}
                  href={location.href}
                  className="block font-body text-sm text-primary-foreground/60 hover:text-accent transition-colors"
                >
                  {location.name}
                </a>
              ))}
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-primary-foreground/10 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center gap-6">
            <div className="text-center md:text-left">
              <p className="font-body text-xs text-primary-foreground/30">
                © 2026 Wild Gates Real Estate Kenya. All rights reserved.
              </p>
              <p className="font-body text-xs text-primary-foreground/30 mt-1">
                Licensed by the Estate Agents Registration Board
              </p>
            </div>
            
            <div className="flex items-center gap-6">
              <span className="font-body text-xs text-primary-foreground/30">
                Discretion Guaranteed
              </span>
              <button
                onClick={scrollToTop}
                className="p-2 bg-accent/10 rounded-lg text-accent hover:bg-accent/20 transition-colors"
                aria-label="Back to top"
              >
                <ArrowUp className="w-4 h-4" />
              </button>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
